"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var react_1 = __importStar(require("react"));
var react_html_parser_1 = __importDefault(require("react-html-parser"));
var PreviewGamesList_1 = require("../PreviewGamesList");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var usePolicy_1 = __importDefault(require("./usePolicy"));
var Policy = function (_a) {
    var title = _a.title, htmlContent = _a.htmlContent, gameCardPlaceholder = _a.gameCardPlaceholder, _b = _a.withButtons, withButtons = _b === void 0 ? true : _b;
    var _c = (0, usePolicy_1.default)(), t = _c.t, games = _c.games, isBreakpoints = _c.isBreakpoints, isDesktop = _c.isDesktop, isSmallDesktop = _c.isSmallDesktop, isTablet = _c.isTablet, isLoading = _c.isLoading;
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var openDeposit = (0, apps_shared_1.useOpenDeposit)();
    var openSignUp = (0, apps_shared_1.useOpenSignUp)();
    var depositHandler = (0, react_1.useCallback)(function () {
        if (isAuth)
            openDeposit();
        else
            openSignUp();
    }, [openDeposit, openSignUp, isAuth]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.inner },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.wrapper },
                react_1.default.createElement("h1", { className: styles_module_scss_1.default.title }, t("policyPages.".concat(title))),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.content }, (0, react_html_parser_1.default)(htmlContent)),
                withButtons && (react_1.default.createElement("div", { className: styles_module_scss_1.default.buttons },
                    react_1.default.createElement(ui_components_1.FixedButton, { onClick: depositHandler, color: "gradient", text: "upper" }, t('translation.deposit')))))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.gamesWrapper },
            react_1.default.createElement("h1", { className: styles_module_scss_1.default.title }, t('policyPages.newGames')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.content }, isLoading ? (react_1.default.createElement(ui_components_1.LoadingWithContainer, null)) : (react_1.default.createElement(PreviewGamesList_1.PreviewGamesList, { games: games, gameCardPlaceholder: gameCardPlaceholder }))))));
};
exports.default = Policy;
